import { CommonModule } from '@angular/common';
import { Component, computed, input, output } from '@angular/core';
import { Icon } from '../../../icon/icon.component';
import { Checkbox } from '../../../checkbox/checkbox.component';
import { SelectHelper } from '../../select.hepler';

@Component({
  selector: 'app-select-group-option',
  templateUrl: './select-group-option.component.html',
  styleUrls: ['./select-group-option.component.scss'],
  standalone: true,
  imports: [CommonModule, Icon, Checkbox],
})
export class SelectGroupOptionComponent {
  bindLabel = input<string>();
  bindValue = input<string>();
  values = input<string[] | string>();

  option = input<any>();
  active = computed(() => {
    for (const value of this.values() || []) {
      if (value == this.value()) {
        return true;
      }
    }

    return false;
  });
  checked = output<boolean>();

  label = computed(() =>
    SelectHelper.get(this.option(), this.bindLabel() || ''),
  );
  value = computed(() =>
    SelectHelper.get(this.option(), this.bindValue() || ''),
  );

  handleCheck(ev: boolean) {
    this.checked.emit(ev);
  }
}
